
<template>
  <div>
    <div class="wl_lsit_box">
      <div class="wl_lsit"  v-for='(item,index) in list' :key='index'>
 
          <div class="flex_b title"  @click="goDetails(item.order_id,item.ship_sn)">
            <b>包裹{{index+1}}</b>
            <qdd-icon
              size="0.6rem"
              name="iconnavigate-right"
              color="#999"
              class="ml168"
            ></qdd-icon>
          </div>
          <div class="kuaidi flex">
            <div class="tubiao"  @click="goDetails(item.order_id,item.ship_sn)">
              <qdd-icon
                size="0.6rem"
                name="iconwuliuche"
                color="red"
                class=""
              ></qdd-icon>
            </div>
            <div class="kuaidi_info">
              <div>快递公司：{{item.ship_name}}</div>
              <div @click="copyLink"
                data-ship_sn="item.ship_sn"
                class="flex cobyDomObjbx "
                >快递单号：{{item.ship_sn}}
                <qdd-icon
                 size="0.4rem"
                  name="iconfuzhiwenjian"
                  color="#999"
                  class="ml10"
                ></qdd-icon>
                <button
                  data-clipboard-action="copy"
                  class="cobyDomObj red"
                  :data-clipboard-text="item.ship_sn"></button>
              </div>
            </div>
          </div>
        <!-- </navigator> -->
      </div>
    </div>

    <mloading v-if="showLoading"></mloading>
  </div>
</template>
<script>
import { sendRequest } from "@/assets/public";
import { Dialog, Toast } from "vant";
import mloading from "@/components/loading.vue";
 import icon from '@/components/iconfont.vue'
export default {
  components: {
      'qdd-icon': icon,
      // mloading
    },
  data() {
    return {
      order_id: "",
      traceCon: [],
      traceShip: {},
      showLoading: true,
    };
  },
  mounted() {

    this.order_id = this.$route.query.xh_id;
    this.getlogList();
  },
  methods: {
  


    // 复制文本内容
    copyLink() {
      let _this = this
      let clipboardObj = new this.clipboard('.cobyDomObj')
      clipboardObj.on('success', function () {
        Toast('复制成功')
      })
      clipboardObj.on('error', function () {
        Toast('复制失败')
      })
    },
  


    async getlogList() {
      this.showLoading = true;
      let { content, status, msg } = await sendRequest("order/orderLogisticsList", {
        order_id: this.order_id,
      });
      if (status == "200") {
        this.showLoading = false;
        this.list = content;
      } else {
        this.showLoading = false;
        Toast(msg);
      }
    },
    goDetails(e,ship_sn){
       this.$router.push({
        name: 'wuliu_info',
        query: { 
          xh_id: e ? e : '',
          ship_sn:ship_sn?ship_sn:'', 
          },
        })
    }
  },
};
</script>
<style scoped>
.cobyDomObjbx{
  position: relative;
}
.cobyDomObj{
  position: absolute;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}
page{
  background: #f9f9f9;
}
.wl_lsit_box{
  padding-bottom: 200rpx;
}
.flex{
  display: flex;
  align-items: center;
}
.wl_lsit{
  width: 13.4rem;
  padding: .4rem;
  background: #fff;
  margin: .4rem auto 0;
  border-radius:.4rem;
}
.flex_b{
  display: flex;
  justify-content: space-between;
}
.title{
  font-size: .56rem;
  font-weight: bolder;
}
.tubiao{
  width: 1.6rem;
  height: 1.6rem;
  background: RGBA(255, 91, 80, 0.2);
  border-radius: .2rem;
  line-height: 1.6rem;
  text-align: center;
  margin-right: .4rem;
}
.kuaidi{
  padding-top: .4rem;
}
.kuaidi_info{
font-size: .52rem;
color: #333;
}
.kuaidi_info view:nth-child(2){
  margin-top: .08rem;
}
.ml10{
  margin-left: .2rem;
}
</style>